import React, { useEffect, useRef, useState } from 'react'
import { Link, useParams } from 'react-router-dom';
import {
  Box,
  Button,
  Table,
  TableContainer,
  Tbody,
  Grid,
  GridItem,
  Textarea,
  Select,
  Spinner,
  Tooltip,
  Image,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  useDisclosure,
} from '@chakra-ui/react';
import TableElement from '@/table/TableElement';
//@ts-ignore
import InputMask from 'react-input-mask';
import { licenseApprovalValidation, regexFullLicense, textareaLengthValidation } from '@/queue/ducks/validationSchema';
import { LicenseReview, ReviewConfirmation } from '@/model/license-review.mjs';
import { fixTimezoneOffset, trimDate } from '@/queue/utils'
import { getFormattedDate, getFormattedDateTime } from '@/queue/elements/value-formatters/date-formatter.mjs';
import { normalizeRejectedReasonFromApi, reviewRejectedReasonsFflLoa, stepMapping } from '@/utils/constants';
import { getFormattedTextForManualReview, getSourceTextForApprovalPage } from '@/utils/utils';
import s3Utils from '@/utils/s3Utils';
import AppConfig from '@/utils/app-config.mjs';
import { MapInteractionCSS } from "react-map-interaction";
import PreviewLicense, { ShowPreview } from '@/common/PreviewLicense';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { updateLicenseApprovalStatus } from '@/api/apis';
import { callToGetLicenseReviewDetails, setIsCertificateStatusUpdated } from '../ducks/slice';
import { useDispatch } from 'react-redux';
import { getLicenseReviewDetails, getLicenseReviewDetailsLoading } from './selector';
import ReviewConfirmationModal from '@/common/ReviewConfirmationModal';
import InvalidCertificateModal from '@/common/InvalidCertificateModal';
import { getDocumentsRequiredDetails, getDocumentsRequiredDetailsLoading, getIsDealerDetailsLoading, getValidLicenseRecord } from '@/queue/ducks/selectors';
import { callToGetDocumentStatus, callToGetLicenseRecordDetails, setDocumentsRequiredDetails, setDocumentsRequiredDetailsLoading } from '@/queue/ducks/slice';
import mime from 'mime-types';
import ControlledInput from '@/common/ControllerInput';
import FlatDatePickr from '@/common/Flatpickr';

const licenseApprovalPage = () => {

  const [licenseReview, setLicenseReview] = useState<LicenseReview | null>(null);
  const [reviewConfirmation, setReviewConfirmation] = useState<ReviewConfirmation>({
    header: "",
    isCancelBtnDisable: false,
    isConfirmBtnDisable: false,
    isConfirmBtnLoading: false,
    isSaveBtnLoading: false,
    rejectedReason: "",
    note: "",
    error: "",
    status: "",
  });
  const [reviewInputVal, setReviewInputVal] = useState<any>({
    rejectReason: "",
    note: "",
  });
  const [imageLoadError, setImageLoadError] = useState<boolean>(false);
  const [downloadingFile1, setDownloadingFile1] = useState<boolean>(false);
  const [downloadingFile2, setDownloadingFile2] = useState<boolean>(false);
  const [invalidCertificate, setInvalidCertificate] = useState<any>({
    header: "",
    note: "The certificate provided appears to be either invalid or corrupted, so unfortunately, we are unable to approve it.",
  });

  const [ocrExpDate, setOcrExpDate] = useState<any>(null);
  const [signatureDate, setSignatureDate] = useState<any>(null);
  const [textareaEvent, setTextareaEvent] = useState<any>(null);
  const blob = new Blob();
  const [licenseBlob, setLicenseBlob] = useState<Blob | null>(blob);
  const [initialLicenseData, setInitialLicenseData] = useState<LicenseReview | null>(null);
  const [dealer_id, setDealerId] = useState<string>('');

  const dispatch = useDispatch();
  const params = useParams();
  const dateExpPickerRef = useRef<any>(null);

  const licenseReviewDetailsLoading = getLicenseReviewDetailsLoading();
  const licenseReviewDetails = getLicenseReviewDetails();
  const documentsRequiredDetails = getDocumentsRequiredDetails();
  const validLicenseRecordDetails = getValidLicenseRecord();
  const isDealerDetailsLoading = getIsDealerDetailsLoading();
  const documentsRequiredDetailsLoading = getDocumentsRequiredDetailsLoading();

  const {
    isOpen: isReviewConfirmationMadalOpen,
    onClose: onCloseReviewConfirmationModal,
    onOpen: onOpenReviewConfirmationModal
  } = useDisclosure();
  const {
    isOpen: isInvalidCertificateMadalOpen,
    onClose: onClosInvalidCertificateModal,
    onOpen: onOpenInvalidCertificateModal
  } = useDisclosure();

  const premiseAddress = useRef(null) as unknown as React.MutableRefObject<HTMLInputElement>;
  const mailingAddress = useRef(null) as unknown as React.MutableRefObject<HTMLInputElement>;

  let imgUrl = '';
  if (licenseBlob && licenseBlob?.type) {
    imgUrl = URL.createObjectURL(licenseBlob);
  }

  const createBolb = async (path: string) => {
    let blob = await s3Utils.getFileBlob(path, 'masterFFLAssets', {
      public: ''
    });
    const contentType =
      mime.lookup(path.split('.').pop() as string) ||
      'application/octet-stream';
    blob = new Blob([blob], { type: contentType });
    setLicenseBlob(blob);
  }

  useEffect(() => {
    if (params.id && !licenseReviewDetailsLoading) {
      dispatch(setDocumentsRequiredDetailsLoading(true))
      dispatch(callToGetLicenseReviewDetails({
        id: params.id
      }))
    }
  }, [params?.id])

  useEffect(() => {
      const licenseKey = licenseReview?.full_license_key?.replace(/[*_-]/g, '');
      const len = licenseKey?.length;
      if (licenseKey && licenseKey.length === 15) {
        dispatch(callToGetLicenseRecordDetails({ id: licenseReview?.full_license_key }));
      } else {
        dispatch(setDocumentsRequiredDetails({}));
        setDealerId('');
      }
    }, [licenseReview?.full_license_key]);

  useEffect(() => {
    if (validLicenseRecordDetails?.dealerId && validLicenseRecordDetails?.fullLicenseKeys?.[0]) {
      dispatch(callToGetDocumentStatus({ id: validLicenseRecordDetails?.fullLicenseKeys?.[0] }));
      setDealerId(validLicenseRecordDetails?.dealerId);
    } else {
      setLicenseReview((prevState: any) => ({
        ...prevState,
        errors: { ...(prevState?.errors || {}), 'full_license_key': 'Enter valid license number' }
      }))
      setDealerId('');
    }
  }, [validLicenseRecordDetails?.dealerId]);

  useEffect(() => {
    if (licenseReview === null || licenseReviewDetails?.id && !licenseReviewDetailsLoading) {
      setInitialLicenseData(licenseReviewDetails);
      const expDate = licenseReviewDetails?.ocr_expiry_date || null;
      setOcrExpDate(expDate ? getFormattedDate(trimDate(expDate)) : null);
      setReviewInputVal({
        rejectReason: normalizeRejectedReasonFromApi(licenseReviewDetails?.rejected_reason ?? null) || "",
        note: licenseReviewDetails?.note || "",
      })
      setLicenseReview(licenseReviewDetails);
      setDealerId(licenseReviewDetails?.dealer_id || "");
      const licenseKey = licenseReviewDetails?.full_license_key?.replace(/[*_-]/g, '');
      createBolb(licenseReviewDetails?.unstamped_license_path || "");
      setImageLoadError(false);
      if (licenseKey && licenseKey.length === 15) {
        dispatch(callToGetLicenseRecordDetails({ id: licenseReviewDetails?.full_license_key }));
      } else {
        dispatch(setDocumentsRequiredDetails({}));
        dispatch(setDocumentsRequiredDetailsLoading(false));
        setDealerId('');
      }
    }
  }, [licenseReviewDetails])

  useEffect(() => {
    premiseAddress?.current?.setSelectionRange(textareaEvent, textareaEvent);
    mailingAddress?.current?.setSelectionRange(textareaEvent, textareaEvent);
  }, [licenseReview?.premise_address, licenseReview?.mailing_address])

  const openExpDatePicker = () => {
    if (dateExpPickerRef.current) {
      dateExpPickerRef.current.setOpen(true);
    }
  };

  const validateField = async (name: string, value: string | Date) => {
    try {
      await licenseApprovalValidation.validateAt(name, { [name]: value });
      setLicenseReview((prevState: any) => ({
        ...prevState,
        errors: { ...(prevState.errors || {}), [name]: '' }
      }));
    } catch (error: any) {
      if (error.errors && error.errors.length > 0) {
        setLicenseReview((prevState: any) => ({
          ...prevState,
          errors: { ...(prevState.errors || {}), [name]: error.errors[0] }
        }));
      }
    }
  };

  const onDateChange = async (date: Date, fieldName: string) => {
    if (fieldName === 'ocr_expiry_date') {
      setOcrExpDate(getFormattedDate(date.toDateString()));
      setLicenseReview((prevState: any) => ({
        ...prevState,
        errors: { ...(prevState.errors || {}), [fieldName]: '' }
      }))
    } else {
      setSignatureDate(getFormattedDate(date.toDateString()));
    }
  }

  const onChangeInputs = async (value: string, fieldName: string) => {
    await validateField(fieldName, value as string);
    setLicenseReview((prevState: any) => ({
      ...prevState,
      [fieldName]: value
    }));
  };

  const getFailedStep = (value: number | null) => {
    let status: string | null = '';
    if (value) {
      status = stepMapping[value?.toString()] || '';
    }
    return status;
  };

  const checkStatus = (currentStatus: string | undefined, status: string) => {
    return currentStatus === status;
  };

  const downloadFile1 = async (path: string) => {
    setDownloadingFile1(true);
    await s3Utils.getFile(path, 'masterFFLAssets', { public: '' });
    setDownloadingFile1(false);
  };
  const downloadFile2 = async (path: string) => {
    setDownloadingFile2(true);
    const res = await s3Utils.getFile(path, 'licenseReader', { public: '' });
    setDownloadingFile2(false);
  };

  const downloadIcon1 = () => {
    return (
      <>
        {downloadingFile1 ? (
          <button className="license_details__download-btn download-license-height">
            <Spinner size="sm" />
          </button>
        ) : (
          <Box
            display={'inline'}
            position={'relative'}
            top={'6px'}
            pl={2}
          >
            <Tooltip
              hasArrow
              placement="top"
              label="Download JPEG Certificate"
              color={'black'}
              bg={'white'}
            >
              <button
                className="license_details__download-btn download-license-height"
                onClick={() => downloadFile1(licenseReview?.unstamped_license_path as string)}
                disabled={!licenseReview?.unstamped_license_path}
              >
                <Image src="/images/ui/download.svg" />
              </button>
            </Tooltip>
          </Box>
        )}
      </>
    );
  };

  const downloadIcon2 = () => {
    return (
      <>
        {downloadingFile2 ? (
          <button className="license_details__download-btn download-license-height">
            <Spinner size="sm" />
          </button>
        ) : (
          <Box
            display={'inline'}
            position={'relative'}
            top={'6px'}
            pl={2}
          >
            <Tooltip
              hasArrow
              placement="top"
              label="Download Original Certificate"
              color={'black'}
              bg={'white'}
            >
              <button
                className="license_details__download-btn download-license-height"
                onClick={() => downloadFile2(licenseReview?.object_path as string)}
                disabled={!licenseReview?.object_path}
              >
                <Image src="/images/ui/download.svg" />
              </button>
            </Tooltip>
          </Box>
        )}
      </>
    );
  };

  const onOpenCertificateStatus = async (status: string) => {
    if (!licenseReview?.unstamped_license_path && status === 'APPROVED') {
      setInvalidCertificate((prev: any) => ({ ...prev, header: "Invalid FFL Certificate" }));
      return onOpenInvalidCertificateModal();
    }

    if (status === "APPROVED") {
      await validateField('full_license_key', licenseReview?.full_license_key ? licenseReview.full_license_key as string : "");
      if (!ocrExpDate) {
        setLicenseReview((prevState: any) => ({
          ...prevState,
          errors: { ...(prevState.errors || {}), 'ocr_expiry_date': 'Expiry date is required.' }
        }))
        return
      }
      if (
        ((initialLicenseData?.full_license_key == null || !regexFullLicense.test(licenseReview?.full_license_key as string)) && (!licenseReview?.full_license_key || licenseReview?.errors && licenseReview.errors.full_license_key)) ||
        (licenseReview?.printed_name && licenseReview?.errors && licenseReview.errors.printed_name) ||
        (licenseReview?.position_title && licenseReview?.errors && licenseReview.errors.position_title)
      ) {
        return
      }
      setReviewConfirmation((prevState: any) => ({
        ...prevState,
        header: "Do you want to approve this license?",
        status: status
      }))
    } else {
      setReviewConfirmation((prevState: any) => ({
        ...prevState,
        header: "Reason of Rejection",
        status: status
      }))
    }
    onOpenReviewConfirmationModal();
  }

  const updateCertificateStatus = async (status: string, isSaveClicked: boolean = false, isEmailIgnored: boolean = false) => {
    try {
      setReviewConfirmation((prevState: ReviewConfirmation) => ({
        ...prevState,
        isConfirmBtnLoading: !isSaveClicked ? true : isSaveClicked,
        isCancelBtnDisable: true,
        isSaveBtnLoading: isSaveClicked,
      }));
      const response = await updateLicenseApprovalStatus(
        licenseReview?.id as string,
        status,
        licenseReview?.full_license_key || "",
        licenseReview?.printed_name,
        licenseReview?.position_title,
        ocrExpDate,
        signatureDate,
        licenseReview?.premise_address,
        licenseReview?.mailing_address,
        reviewConfirmation?.rejectedReason,
        reviewConfirmation?.note,
        isEmailIgnored
      );
      if (response.status === 200) {
        dispatch(setIsCertificateStatusUpdated(true));
      }
      closeReviewConfirmationModal();
    } catch (err: any) {
      console.log('ERROR', err);
      if (
        err &&
        err?.response &&
        err.response?.status == 404 &&
        err.response?.data &&
        err.response.data?.Error
      ) {
        setLicenseReview((prevState: any) => ({
          ...prevState,
          errors: { ...(prevState.errors || {}), 'full_license_key': err.response.data?.Error }
        }))
      }
    } finally {
      setReviewConfirmation((prevState: ReviewConfirmation) => ({
        ...prevState,
        isConfirmBtnLoading: false,
        isCancelBtnDisable: false,
        isSaveBtnLoading: false,
      }));
      onCloseReviewConfirmationModal();
      dispatch(callToGetLicenseReviewDetails({
        id: params.id
      }))
    }
  };

  const onSave = async () => {
    await validateField('full_license_key', licenseReview?.full_license_key ? licenseReview.full_license_key as string : "");
    if (!ocrExpDate) {
      setLicenseReview((prevState: any) => ({
        ...prevState,
        errors: { ...(prevState.errors || {}), 'ocr_expiry_date': 'Expiry date is required.' }
      }))
      return
    }
    updateCertificateStatus(licenseReview?.approval_status ? licenseReview?.approval_status.toUpperCase() : "PENDING", true)
  }

  const closeReviewConfirmationModal = () => {
    onCloseReviewConfirmationModal();
    setReviewConfirmation({
      header: "",
      isCancelBtnDisable: false,
      isConfirmBtnDisable: false,
      isConfirmBtnLoading: false,
      isSaveBtnLoading: false,
      rejectedReason: "",
      note: "",
      error: "",
      status: "",
    });
  }

  const disableConfirmButton = () => {
    if (reviewConfirmation.error || (reviewConfirmation.status === "REJECTED" && !reviewConfirmation.rejectedReason)) {
      return true;
    }
    return false;
  }

  const handleChange = async (event: any) => {
    setReviewConfirmation((prevState: ReviewConfirmation) => ({
      ...prevState,
      rejectedReason: event.target.value
    }));
  };

  const handleTextChange = async (event: any) => {
    const value = event.target.value;
    try {
      await textareaLengthValidation.validateAt('textarea', { 'textarea': value });
      setReviewConfirmation((prevState: ReviewConfirmation) => ({
        ...prevState,
        note: event.target.value,
        error: ''
      }));
    } catch (error: any) {
      if (error.errors && error.errors.length > 0) {
        setReviewConfirmation((prevState: ReviewConfirmation) => ({
          ...prevState,
          error: error.errors[0]
        }));
      }
    }
  };




  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', maxHeight: 'calc(100vh - 225px)' }}>
      {(licenseReviewDetailsLoading || documentsRequiredDetailsLoading) && (
        <Box sx={{ position: 'fixed', zIndex: 1000, height: '100%', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(0, 0, 0, 0.2)', top: 0, left: 0 }} >
          <Spinner
            size="lg"
          />
        </Box>
      )}
      <Box className="transfer_flex_row" sx={{ marginBottom: 3 }}>
        <Breadcrumb
          spacing="3px"
          separator={
            <ChevronRightIcon className="right-arrow" color="#323232" />
          }
        >
          <BreadcrumbItem className="breadcrumb-item">
            <BreadcrumbLink
              className="breadcrumb-link"
              as={Link}
              to="/admin/license-approval"
            >
              License Approval
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbItem className="breadcrumb-item">
            <span className="breadcrumb-link breadcrumb-text">
              License Approval Details
            </span>
          </BreadcrumbItem>
        </Breadcrumb>
        <Box sx={{ display: 'flex', justifyContent: { base: 'flex-start', lg: 'flex-end' }, flexGrow: 1, flexWrap: 'wrap', paddingTop: { base: 3, lg: 0 } }}>
          {(!imageLoadError && licenseReview?.unstamped_license_path) ? <TableElement
            type="review"
            label={'License Preview'}
            className="license-file-path"
            renderFunction={downloadIcon1}
            mb={3}
          ></TableElement> : <div></div>}
          <TableElement
            type="review"
            label={'Original File'}
            className="license-file-path"
            renderFunction={downloadIcon2}
            mb={3}
          ></TableElement>
          <Button
          colorScheme="blue"
          background="#ffffff"
          color="#0C1E46"
          border="1px solid #0C1E46"
          padding="8px 20px"
          marginRight="20px"
            isLoading={reviewConfirmation.isSaveBtnLoading}
            sx={{ outline: 'none !important' }}
            isDisabled={
              (licenseReview &&
                licenseReview?.errors &&
                Object.values(licenseReview?.errors).some((val) => val !== '') ? true : false)
            }
            onClick={() => { onSave() }}
          >
            Save
          </Button>
          <Button
            leftIcon= {<Image src="/images/ui/success.svg" />}
            {...(checkStatus(licenseReview?.approval_status, "approved") && { isDisabled: true })}
            {...( { colorScheme: "green", variant: 'outline' })}
            padding="8px 20px"
            marginRight="20px"
            sx={{ outline: 'none !important' }}
            onClick={() => { onOpenCertificateStatus("APPROVED") }}
          >
            {!checkStatus(licenseReview?.approval_status, "approved") ? "Approve" : "Approved"}
          </Button>
          <Button
            leftIcon= {<Image src="/images/ui/reject.svg" />}
            {...( { colorScheme: "red", border: "1px solid red", padding: "8px 20px" })}
            onClick={() => { onOpenCertificateStatus("REJECTED") }}
            sx={{ outline: 'none !important' }}
            {...({ variant: 'outline' })}
            {...(checkStatus(licenseReview?.approval_status, "rejected") && { isDisabled: true })}
          >
            {!checkStatus(licenseReview?.approval_status, "rejected") ? "Reject" : "Rejected"}
          </Button>
        </Box>
      </Box>
      <Box sx={{ flexGrow: 1 }}>
        <Grid templateColumns={{ base: '1fr', md: '50% 50%', xl: '20% 20% 20% 40%' }}>
          <GridItem pb={6} colSpan={{ base: 1, xl: 2 }}>
            <TableContainer>
              <Table>
                <Tbody>
                  <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px', marginBottom: 3, alignItems: 'start' }}>
                    <Box sx={{ minWidth: 0, maxWidth: '320px' }}>
                      <TableElement noBorder={true} type="review"
                        mb={3}
                        label={
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        License Number
                        {(dealer_id) && (
                          <img
                            src="/images/ui/blue-link.svg"
                            alt="License"
                            onClick={(e) => {
                              e.stopPropagation();
                              console.log({ dealer_id: dealer_id });
                              window.open(`/dealers-search/${dealer_id}`, '_blank');
                            }}
                            style={{
                              width: '16px',
                              height: '16px',
                              cursor: 'pointer'
                            }}
                          />
                        )}
                      </div>
                    }
                  >
                    <Box sx={{ position: 'relative' }}>
                      <InputMask
                        id="formattedInput"
                        mask="9-99-999-99-9a-99999"
                        placeholder="X-XX-XXX-XX-XX-XXXXX"
                        value={licenseReview?.full_license_key || ""}
                        onChange={(event: any) =>
                          onChangeInputs(
                            event.target.value,
                            'full_license_key'
                          )
                        }
                      >
                        {(inputProps: any) => <input
                          {...inputProps}
                          type="text"
                          className='sot-customize-input'
                        />
                        }
                      </InputMask>
                      {isDealerDetailsLoading && (
                        <Spinner
                          size="sm"
                          style={{
                            position: 'absolute',
                            right: '8px',
                            top: '25%',
                            transform: 'translateY(-50%)',
                            pointerEvents: 'none'
                          }}
                        />
                      )}

                      {licenseReview?.errors && licenseReview?.errors?.full_license_key ?
                        <div className="">
                          <div className="edit-error">
                            {licenseReview.errors && licenseReview?.errors.full_license_key && (
                              <>* {licenseReview?.errors.full_license_key}</>
                            )}
                          </div>
                        </div> : ""
                      }
                    </Box>
                  </TableElement>
                    </Box>
                    <Box sx={{ minWidth: 0, maxWidth: '320px' }}>
                      <TableElement noBorder={true} label={'License Responsible Name'} type="review" mb={3}>
                        <ControlledInput
                          className="license-review__input contact-detail-form__contact-name"
                          type="text"
                          placeholder="Enter Name"
                          value={licenseReview?.printed_name || ""}
                          onChange={(event) =>
                            onChangeInputs(
                              event.target.value,
                              'printed_name'
                            )
                          }
                        />
                        {licenseReview?.errors && licenseReview?.errors?.printed_name ?
                          <div className="">
                            <div className="edit-error">
                              {licenseReview.errors && licenseReview?.errors.printed_name && (
                                <>* {licenseReview.errors?.printed_name}</>
                              )}
                            </div>
                          </div> : ""
                        }
                      </TableElement>
                    </Box>
                  </Box>
                  <TableElement label={''} type="review" mb={3}>
                    <Box className="transfer_flex_row" sx={{ gap: '8px', alignItems: 'flex-end' }}>
                      <Box className={`doc_box ${documentsRequiredDetails.hasValidCertificate ? 'doc_active' : ''}`}>FFL License</Box>
                      <Box className={`doc_box ${documentsRequiredDetails?.hasValidSOT ? 'doc_active' : ''}`}>SOT</Box>
                      <Box className={`doc_box ${documentsRequiredDetails?.hasValidLOA ? 'doc_active' : ''}`}>LOA</Box>
                    </Box>
                  </TableElement>
                  <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px', marginBottom: 3, minWidth: 0 }}>
                    <Box sx={{ minWidth: 0, maxWidth: '320px' }}>
                      <TableElement label={'OCR Expiry Date'} type="review" mb={3}>
                        <Box>
                          <FlatDatePickr
                          label=""
                          classNameValue="transfer-form__input order-date-picker"
                          value={fixTimezoneOffset(ocrExpDate)}
                          onDateChange={(date: Date) => onDateChange(date, 'ocr_expiry_date')}
                          options={{ minDate: "today" }}
                        />
                        {licenseReview?.errors && licenseReview?.errors?.ocr_expiry_date ?
                          <div className="">
                            <div className="edit-error">
                              {licenseReview.errors && licenseReview?.errors.ocr_expiry_date && (
                                <>* {licenseReview?.errors.ocr_expiry_date}</>
                              )}
                            </div>
                          </div> : ""
                          }
                        </Box>
                      </TableElement>
                    </Box>
                    <Box sx={{ minWidth: 0 }}>
                      <TableElement label={'ATF Expiry Date'} type="review" mb={3}>
                        {documentsRequiredDetails?.atfExpiryDate ? getFormattedDate(fixTimezoneOffset(documentsRequiredDetails?.atfExpiryDate as any)) : ''}
                      </TableElement>
                    </Box>
                  </Box>

                  <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px', marginBottom: 3, minWidth: 0 }}>
                    <Box sx={{ minWidth: 0 }}>
                      <TableElement label={'OCR Premises Address'} type="review" mb={3} color={(licenseReview?.status === '55' && licenseReview?.is_premise_address_changed) ? '#c84646' : 'black'}>
                        {licenseReview?.premise_address || ""}
                      </TableElement>
                    </Box>
                    <Box sx={{ minWidth: 0 }}>
                      <TableElement label={'ATF Premises Address'} type="review" mb={3}>
                        {documentsRequiredDetails?.premiseAddress?.street ? (
                          <>{documentsRequiredDetails.premiseAddress.street}, {documentsRequiredDetails.premiseAddress.city}, {documentsRequiredDetails.premiseAddress.state}, {documentsRequiredDetails.premiseAddress.zipCode}</>
                        ) : ''}
                      </TableElement>
                    </Box>
                  </Box>

                  <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px', marginBottom: 3, minWidth: 0 }}>
                    <Box sx={{ minWidth: 0 }}>
                      <TableElement label={'OCR Mailing Address'} type="review" mb={3} color={(licenseReview?.status === '55' && licenseReview?.is_mailing_address_changed) ? '#c84646' : 'black'}>
                        {licenseReview?.mailing_address || ""}
                      </TableElement>
                    </Box>
                    <Box sx={{ minWidth: 0 }}>
                      <TableElement label={'ATF Mailing Address'} type="review" mb={3}>
                        {documentsRequiredDetails?.mailingAddress?.street ? (
                          <>{documentsRequiredDetails.mailingAddress.street}, {documentsRequiredDetails.mailingAddress.city}, {documentsRequiredDetails.mailingAddress.state}, {documentsRequiredDetails.mailingAddress.zipCode}</>
                        ) : ''}
                      </TableElement>
                    </Box>
                  </Box>
                  <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px', marginBottom: 3, minWidth: 0 }}>
                    <Box sx={{ minWidth: 0 }}>
                      <TableElement label={'OCR License Name'} type="review" mb={3} color={(licenseReview?.error_code === 56 && licenseReview?.is_license_name_changed) ? '#c84646' : 'black'}>
                        {licenseReview?.ocr_license_name ?? '-'}
                      </TableElement>
                    </Box>
                    <Box sx={{ minWidth: 0 }}>
                      <TableElement label={'ATF License Name'} type="review" mb={3}>
                        {documentsRequiredDetails?.licenseName ?? licenseReview?.license_name ?? '-'}
                      </TableElement>
                    </Box>
                  </Box>

                  <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px', marginBottom: 3, minWidth: 0 }}>
                    <Box sx={{ minWidth: 0 }}>
                      <TableElement label={'OCR Business Name'} type="review" mb={3} color={(licenseReview?.error_code === 56 && licenseReview?.is_business_name_changed) ? '#c84646' : 'black'}>
                        {licenseReview?.ocr_business_name ?? '-'}
                      </TableElement>
                    </Box>
                    <Box sx={{ minWidth: 0 }}>
                      <TableElement label={'ATF Business Name'} type="review" mb={3}>
                        {documentsRequiredDetails?.businessName ?? licenseReview?.business_name ?? '-'}
                      </TableElement>
                    </Box>
                  </Box>
                </Tbody>
              </Table>
            </TableContainer>
          </GridItem>
          <GridItem pb={6}>
            <TableContainer>
              <Table>
                <Tbody>
                  <TableElement label={'Status'} type="review" mb={3}>
                    {licenseReview?.status === '0' ? 'Success' : 'Failed'}
                  </TableElement>
                  <TableElement label={'Source of FFL'} type="review" mb={3}>
                    {getSourceTextForApprovalPage(licenseReview?.source, 'License')}
                  </TableElement>
                  <TableElement label={'Uploaded Date'} type="review" mb={3}>
                    {licenseReview?.created_date_time
                      ? getFormattedDateTime(new Date(licenseReview?.created_date_time)) : ''}
                  </TableElement>
                  <TableElement label={'Failure Reason'} type="review" mb={3}>
                    {getFailedStep(licenseReview?.error_code || null)}
                  </TableElement>
                  <TableElement label={'Rejection Reason'} type="review" mb={3}>
                  {checkStatus(licenseReview?.approval_status, "rejected") && (
                    <>
                      <Select
                        placeholder='Select reason*'
                        my={3}
                        value={reviewInputVal?.rejectReason ?? ''}
                        onChange={(event) => {
                          setReviewConfirmation({
                            ...reviewConfirmation,
                            rejectedReason: event.target.value,
                          })
                          setReviewInputVal({ ...reviewInputVal, rejectReason: event.target.value })
                        }}
                        disabled={!checkStatus(licenseReview?.approval_status, "rejected")}
                        required
                      >{
                          Object.entries(reviewRejectedReasonsFflLoa).map(([key, val]) => <option value={val as string} selected={val === reviewInputVal?.rejectReason}>{val as string}</option>)
                        }
                      </Select>
                    </>
                  )}
                  </TableElement>
                  <TableElement label={'Rejection Notes'} type="review" mb={3}>
                    <>
                      <Textarea
                        className="license-review__input contact-detail-form__contact-name"
                        value={reviewInputVal?.note || ""}
                        onChange={(e) => {
                          setReviewConfirmation({
                            ...reviewConfirmation,
                            note: e.target.value,
                          })
                          setReviewInputVal({
                            ...reviewInputVal,
                            note: e.target.value,
                          })
                        }}
                        disabled={checkStatus(licenseReview?.approval_status, "pending")}
                      />
                    </>
                  </TableElement>
                  <TableElement label={'Manual Review Requester'} type="review" mb={3}>
                    {licenseReview?.action_performed_by
                      ? getFormattedTextForManualReview(licenseReview?.action_performed_by, licenseReview?.manual_review_requested_by) : ''}
                  </TableElement>
                  <TableElement label={'Manual Review Request Date'} type="review" mb={3}>
                    {licenseReview?.manual_review_requested_at
                      ? getFormattedDateTime(licenseReview?.manual_review_requested_at) : ''}
                  </TableElement>
                </Tbody>
              </Table>
            </TableContainer>
          </GridItem>

          <Grid templateRows={{ base: '60px auto' }}>
            <GridItem
              w={"100%"}
              h={'auto'}
            >
              <TableContainer display='flex' justifyContent='center' alignItems={"center"}>
                <Table>
                  <Tbody>
                    <Box w='100%' className='license-image' sx={{ maxWidth: '745px !important'}}>
                      {licenseReview?.unstamped_license_path && !(licenseReview?.unstamped_license_path.split('.').pop() === 'pdf') && <MapInteractionCSS
                        showControls
                        defaultValue={{
                          scale: 1,
                          translation: { x: 0, y: 20 }
                        }}
                        minScale={0.5}
                        maxScale={3}
                        translationBounds={{
                          xMax: 400,
                          yMax: 200
                        }}
                        btnClass={'map-interection-buttons'}
                      >
                        <img src={imgUrl || ''} width='100%' height="" alt={imageLoadError ? " " : 'Loading...'} className={""}
                          onLoad={() => {
                            imgUrl && setImageLoadError(false);
                          }}
                          onError={() => {
                            imgUrl && setImageLoadError(true);
                          }}
                        />
                      </MapInteractionCSS>}
                    </Box>
                  </Tbody>
                </Table>
              </TableContainer>
            </GridItem>

            <GridItem
              display={!licenseBlob?.size ? "flex" : ""}
              justifyContent={"center"}
              alignItems={"start"}
              w={"100%"}
              h={'auto'}
            >
              <TableContainer>
                <Table>
                  <Tbody>
                    <Box w='100%'>
                      {licenseReview?.unstamped_license_path && (licenseReview?.unstamped_license_path.split('.').pop() === 'pdf') &&
                        <ShowPreview blob={licenseBlob} id={"license-preview-iframe"} className={"license-preview-loader"} />
                      }
                    </Box>
                  </Tbody>
                </Table>
              </TableContainer>
            </GridItem>
          </Grid>
        </Grid>
      </Box>
      <ReviewConfirmationModal
        isOpen={isReviewConfirmationMadalOpen}
        onClose={() => {
          setReviewConfirmation({
            ...reviewConfirmation,
            rejectedReason: '',
            note: '',
            error: '',
          })
          closeReviewConfirmationModal()
        }}
        modalHeader={reviewConfirmation.header}
        isCancelBtnDisable={reviewConfirmation.isCancelBtnDisable}
        isConfirmBtnDisable={disableConfirmButton()}
        isConfirmBtnLoading={reviewConfirmation.isConfirmBtnLoading}
        onClickConfirmBtn={(isEmailIgnored) => { updateCertificateStatus(reviewConfirmation.status, false, isEmailIgnored) }}
        fields={reviewRejectedReasonsFflLoa}
        selectedValue={reviewConfirmation.rejectedReason}
        handleChange={handleChange}
        handleTextChange={handleTextChange}
        hideDropdown={reviewConfirmation.status !== "APPROVED"}
        error={reviewConfirmation.error}
        approvalDetails={licenseReview}
      />
      <InvalidCertificateModal
        isOpen={isInvalidCertificateMadalOpen}
        onClose={onClosInvalidCertificateModal}
        modalHeader={invalidCertificate.header}
        note={invalidCertificate.note}
      />
    </Box>
  )
}

export default licenseApprovalPage